module.exports = __webpack_public_path__ + "img/img11.ec8e4688.png";